export const NOT_APPLICABLE = 'N/A' as const;

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 20;
/** The one set of page sizes a list offers (CUR-1341). */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const MAX_PAGE_SIZE = 100;

/**
 * Default maximum number of records accessible via pagination on the client.
 * Users must use filters to access records beyond this limit.
 * This prevents performance issues with large OFFSET values in PostgreSQL.
 */
export const DEFAULT_MAX_ACCESSIBLE_RECORDS = 500;

/**
 * Hard server-side limit for offset values.
 * Acts as a security safeguard - should be higher than DEFAULT_MAX_ACCESSIBLE_RECORDS.
 * Requests with offset > this value will be rejected by Zod validation.
 */
export const HARD_OFFSET_LIMIT = 1000;

/**
 * Largest `limit` a list route may opt into above MAX_PAGE_SIZE, for a caller that loads a whole
 * reference list (a picker, the supplier map) or an export in one request. A route that raises its
 * limit names that caller.
 */
export const MAX_LIST_LIMIT = 1000;

/**
 * Offset cap for lists of records that keep growing with use (documents, history, training records,
 * attestations, users), where browsing legitimately pages past HARD_OFFSET_LIMIT. A table over such
 * a list sets `maxAccessibleRecords` to this value so navigation stops before the server refuses.
 */
export const DEEP_LIST_OFFSET_LIMIT = 10_000;

/**
 * Maximum length of the raw `query` text `global.globalSearch` accepts for claim-reference
 * resolution. Shared so the ⌘K client drops an over-long query instead of tripping the server's
 * Zod bound and failing the whole search — the two sides must never disagree on this number.
 */
export const GLOBAL_SEARCH_QUERY_MAX_LENGTH = 256;
